module.exports = __webpack_public_path__ + "87b9b4faca9ae68c55dab6485a4fb35c.png";